import React, { useEffect, useMemo } from "react";
import { Modal, Spinner } from "reactstrap";
import Select from "react-select";
import moment from "moment";

const BatchModal = ({ loading, show, mode, formData, setFormData, onSubmit, onClose }) => {
  if (!show) return null;

  const isCreate = mode === "create";
  
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const dayOptions = days.map((day) => ({
    label: day,
    value: day,
  }));

  const timeSlots = useMemo(() => {
    const selectedDay = formData.Batch_Day;

    if (!selectedDay) return [];

    const isWeekend =
      selectedDay === "Saturday" ||
      selectedDay === "Sunday";

    const startHour = isWeekend ? 10 : 16;
    const endHour = 22;

    const slots = [];

    for (let hour = startHour; hour < endHour; hour++) {
      const start = moment({ hour }).format("h:mmA");
      const end = moment({ hour: hour + 1 }).format("h:mmA");

      slots.push({
        label: `${start} - ${end}`,
        value: `${start} - ${end}`,
      });
    }

    return slots;
  }, [formData.Batch_Day]);

  useEffect(() => {
    if (formData.Batch_Day && formData.Batch_Time) {
      const shortDay = formData.Batch_Day.substring(0, 3);

      const times = formData.Batch_Time.split(" - ");

      const start = moment(times[0], "h:mmA").format("h");
      const end = moment(times[1], "h:mmA").format("h");

      const generatedName = `${shortDay} Batch ${start}-${end}`;

      setFormData((prev) => ({
        ...prev,
        Name: generatedName,
      }));
    }
  }, [formData.Batch_Day, formData.Batch_Time, setFormData]);

  return (
    <Modal
      isOpen={show}
      toggle={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <form
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.currentTarget.requestSubmit();
          }
        }}
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {isCreate ? "Create Batch" : "Edit Batch"}
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={onClose}
          ></button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div className="text-center my-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <div className="mb-3">
                <label className="form-label">
                  Batch Day*
                </label>
                <Select
                  value={
                    dayOptions.find(
                      (option) =>
                        option.value === formData.Batch_Day
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setFormData({
                      ...formData,
                      Batch_Day: selectedOption
                        ? selectedOption.value
                        : "",
                      Batch_Time: "",
                    })
                  }
                  required
                  isClearable
                  options={dayOptions}
                  classNamePrefix="select2-selection"
                  placeholder="Select Day"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Batch Time*
                </label>
                <Select
                  value={
                    timeSlots.find(
                      (option) =>
                        option.value === formData.Batch_Time
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setFormData({
                      ...formData,
                      Batch_Time: selectedOption
                        ? selectedOption.value
                        : "",
                    })
                  }
                  required
                  isClearable
                  isDisabled={!formData.Batch_Day}
                  options={timeSlots}
                  classNamePrefix="select2-selection"
                  placeholder="Select Time"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Batch Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.Name || ""}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Batch Capacity*
                </label>
                <input
                  type="number"
                  min={1}
                  max={50}
                  step={1}
                  className="form-control"
                  value={formData.Max_Students || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      Max_Students: e.target.value,
                    })
                  }
                  required
                />
              </div>

              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isActive"
                  checked={!!formData.IsActive}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      IsActive: e.target.checked,
                    })
                  }
                />
                <label
                  className="form-check-label"
                  htmlFor="isActive"
                >
                  Is Active?
                </label>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
          >
            Close
          </button>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {isCreate ? "Create" : "Save Changes"}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default BatchModal;